import 'twin.macro';
import { HeaderWrapper } from 'containers/Header/HeaderWrapper';
import React from 'react';
import { UserProfileButton } from '@teetsh/app/src/containers/Header/UserProfileButton';
import { UserAccount } from 'types/user';

export const HEIGHT_HEADER = 64;

interface Props {
  children?: React.ReactNode;
  noMobile?: boolean;
  userAccount?: UserAccount;
  withSubHeader?: boolean;
}

export function HeaderComponent(props: Props) {
  const { children, noMobile, withSubHeader } = props;

  return (
    <>
      <HeaderWrapper
        noMobile={noMobile}
        withSubHeader={withSubHeader}
        rightContent={
          <UserProfileButton
            userAccount={props.userAccount}
            noPremiumButton={noMobile}
          />
        }
      >
        {children}
      </HeaderWrapper>
    </>
  );
}
